/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import api from "./api.client"

/*
Generic GET
*/

export async function apiGet(url, params = {}) {

    const res = await api.get(url, { params })

    return res.data

}

/*
Generic POST
*/

export async function apiPost(url, data = {}) {

    const res = await api.post(url, data)

    return res.data

}

/*
Generic PUT
*/

export async function apiPut(url, data = {}) {

    const res = await api.put(url, data)

    return res.data

}

/*
Generic DELETE
*/

export async function apiDelete(url) {

    const res = await api.delete(url)

    return res.data

}